import React,{ useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Container, Drawer, Box, TextField, Typography,  } from '@mui/material';
import { MdOutlineClose, MdOutlineMultipleStop} from "react-icons/md";
import DataTable from '../Tables/DataTable';
import useComunidades from '../../hooks/useComunidades';
import SearchProgresState from '../filtros/SearchProgresState';
import { listAAFFs, reasignarFincasAAFF } from "../../services";
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';

const DrawerAsignComunidades = ({anchor, open, setOpen, aaff_id, onSuccess}) => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const location = useLocation();
    const {data, loading, fetchData} = useComunidades({aaff_id:aaff_id});
    const [selected, setSelected] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [aaff, setAaff] = useState([]);
    const [aaffSelectected, setAaffSelectected] = useState(null);
    const [valuesToSend, setValuesToSend] = useState({});
    
    const clearAaffFilterAndClose = () => {
        setSelected([]);
        setAllSelected(false);
       
        setAaff([]);
        setAaffSelectected(null);
     
        setValuesToSend({});
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('aaff_id');
        
        // Navegar a la misma ruta pero sin el parámetro aaff_id
        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
        setOpen(false);
    };
    const headersComunidades = [
        {
              id: "nif",
              numeric: false,
              disablePadding: false,
              label: t('form.nif'),
              overrideFunc: (data, row) => (

                <Typography style={{ textAlign: 'left'}}>
                {data}
                </Typography>
              )
            },
        {
            id: "razonSocial",
            numeric: false,
            disablePadding: false,
            label: t('filters.community').toUpperCase(),
            overrideFunc: (data, row) => (
                <Typography style={{ textAlign: 'left'}}>
                    {row?.finca?.razonSocial}
                </Typography>
            )
        },
    ];
    const searchAaff = async (name, value) => {
        if(name === "aaff_add"){
            const { data } = await listAAFFs({
                filtros: {
                    razonSocial: value,
                }
            });
            const sortedData = data.sort((a, b) => {
                return a.razonSocial.localeCompare(b.razonSocial);
            });
            setAaff(sortedData);
            if(sortedData.length === 1){
                setAaffSelectected(sortedData[0]);
            } else {
                // Si hay más de uno o ninguno, limpiar la selección
                setAaffSelectected(null);
            }
        }
        
    };
    const handleAsynchronousChange = (name, selectedValue) => {
        setAaffSelectected(selectedValue); // Más simple y directo
    };
    const sendData = async () => {
        const dataToSend = {
            comunidades: allSelected ? allSelected : selected,
            aaff_idActual: aaffSelectected ? aaffSelectected.id : null,
            aaff_idAnterior: aaff_id,
        };
        
        // Opcional: actualizar el estado para otras funciones que lo necesiten
        setValuesToSend(dataToSend);
        
        // Usar directamente dataToSend para el envío
        const response = await reasignarFincasAAFF(dataToSend);
    
        if(response && response.status === 200){
            toast.success(t('reassignment.success'));
            clearAaffFilterAndClose();
            onSuccess?.();
        } else if(response && response && response.status === 403){
            toast.error(t('reassignment.error') + ": " + response.data.error[0]);
        } else {
            toast.error(t('reassignment.error'));
        }
    };
    return ( 
        <>
            <Drawer
                anchor={anchor}
                open={open}
                onClose={() => clearAaffFilterAndClose()}
            >
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'flex-start', 
                    alignItems: 'center',
                    padding: '10px',
                }}>
                    <button 
                        className='btnCloseDrawer' 
                        onClick={() => clearAaffFilterAndClose()}
                        style={{ marginRight: 'auto' }}
                    >
                        <MdOutlineClose size={30} />
                    </button> 
                </div>

                <Container>
                    <h1 style={{ marginBottom: '20px' }}>{t('reassignment.title')}</h1>
                    <Box mx={1} display={"flex"} flexDirection={"row"} gap={1} alignItems="center">
                        <SearchProgresState
                            labelId="aaff-label"
                            id="aaff-select"
                            label={t('reassignment.propertyManager')}
                            name="aaff_add"
                            className="filtros altura"
                            tipo="razonSocial"
                            array={aaff}
                            onOptionSelected={handleAsynchronousChange}
                            busquedaInput={searchAaff}
                            valueOnLoad={
                                aaff.find((c) => c.id === aaffSelectected?.id) || null
                            }
                        />
                        <button className='bigBtn' onClick={sendData}>
                            <MdOutlineMultipleStop /> {t('reassignment.reassign')}
                        </button>
                    </Box>
                    <Box mx={1} display={"flex"} flexDirection={"row"} gap={2} alignItems="center" marginTop={2}>
                        {t('reassignment.selectedPropertyManager')}: <b>{aaffSelectected ? aaffSelectected.razonSocial : t('reassignment.none')}</b>
                    </Box>
                    <DataTable
                        isLoading={loading}
                        headers={headersComunidades}
                        data={data.rows?.filter(row => !row.isWorkcenter) || []}
                        meta={data.meta}
                        loading={loading}
                        fetcher={fetchData}
                        enableSection={true}
                        setSelected={setSelected}
                        selected={selected}
                        allSelected={allSelected}
                        setAllSelected={setAllSelected}
                    />
                </Container>
            </Drawer>
        </> 
    );
}
 
export default DrawerAsignComunidades;